import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'डॉ. राजेंद्र शेंडे';
const SITE_URL = 'https://rajendrashende.blog';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;
const TWITTER_HANDLE = '@RajendraShende';

const DEFAULT_DESCRIPTION =
  'डॉ. राजेंद्र शेंडे यांचे अधिकृत मराठी संकेतस्थळ — हवामान कार्यकर्ते, माजी UNEP संचालक, IPCC लेखक, Green TERRE Foundation संस्थापक.';

const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  canonical,
  image = DEFAULT_IMAGE,
  type = 'website',
  article,     // { publishedTime, modifiedTime, author, tags }
  breadcrumbs, // [{ name, url }]
  noindex = false,
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — हवामान कार्यकर्ते, UNEP माजी संचालक`;
  const canonicalUrl = canonical ? `${SITE_URL}${canonical}` : undefined;

  const breadcrumbSchema = breadcrumbs?.length
    ? {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbs.map((crumb, i) => ({
          '@type': 'ListItem',
          position: i + 1,
          name: crumb.name,
          item: `${SITE_URL}${crumb.url}`,
        })),
      }
    : null;

  const articleSchema =
    type === 'article' && article
      ? {
          '@context': 'https://schema.org',
          '@type': 'Article',
          headline: title,
          description,
          image,
          datePublished: article.publishedTime,
          dateModified: article.modifiedTime || article.publishedTime,
          author: { '@type': 'Person', name: article.author || 'डॉ. राजेंद्र शेंडे' },
          publisher: {
            '@type': 'Person',
            name: 'Dr. Rajendra Shende',
            url: SITE_URL,
          },
          inLanguage: 'mr',
        }
      : null;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta httpEquiv="content-language" content="mr" />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content={type === 'article' ? 'article' : 'website'} />
      <meta property="og:locale" content="mr_IN" />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      {article?.publishedTime && <meta property="article:published_time" content={article.publishedTime} />}

      {/* Twitter Card */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:creator" content={TWITTER_HANDLE} />

      {/* Alternate language */}
      <link rel="alternate" hreflang="mr" href={canonicalUrl || SITE_URL} />
      <link rel="alternate" hreflang="en" href={`https://rajendrashende.com`} />

      {/* Structured data */}
      {breadcrumbSchema && (
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      )}
      {articleSchema && (
        <script type="application/ld+json">
          {JSON.stringify(articleSchema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
